import { CircularProgress, makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

export function useActivity() {
  const [activity, setActivity] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    fetch(`https://api.edicionesmilenio.com/api/evaluations/${id}`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data?.data);
        setActivity(data?.data);
        setIsLoading(false);
      });
  }, [id]);

  return { activity, isLoading };
}

function ContextQuestion({ question, number }) {
  const classes = useStyles();
  return (
    <div className={classes.contextQuestionRoot}>
      <h5 className={classes.questionAnnouncement}>
        {number}) {question?.question}
      </h5>
    </div>
  );
}

function AloneQuestion({ question, number }) {
  const classes = useStyles();
  return (
    <div>
      <h2>
        {number}) {question?.question}
      </h2>
      {question?.image && (
        <img
          className={classes.questionImage}
          src={'https://api.edicionesmilenio.com' + question?.image}
        />
      )}
    </div>
  );
}

function QuestionAnswers({ answers }) {
  const classes = useStyles();
  return answers?.options.map((answer, index) => {
    return (
      <div className={classes.answerOptionsRoot}>
        <div className={classes.questionOption}>
          <span className={classes.questionOptions}>
            {String.fromCharCode(index + 97)}) {answer?.option}
          </span>
          <span className={classes.questionCorrectIndicator}>
            {answers?.correctIndex === index && '(Respuesta correcta)'}
          </span>
        </div>
        {answer?.image && (
          <img
            className={classes.optionImage}
            src={'https://api.edicionesmilenio.com' + answer?.image}
          />
        )}
      </div>
    );
  });
}

function ContextQuestions({ question, number }) {
  const classes = useStyles();
  return (
    <>
      <h2>
        {number}) {question?.title}
      </h2>
      {question?.images[0] && (
        <img
          className={classes.activityImage}
          src={'https://api.edicionesmilenio.com' + question?.images[0]}
        />
      )}
      <p className={classes.questionDescription}>{question?.description}</p>
      {question?.questions?.map((q, index) => {
        return (
          <div>
            <ContextQuestion
              number={number?.toString() + '.' + (index + 1)}
              question={q}
              key={q?._id}
            />
            <QuestionAnswers answers={q?.questionAnswers} />
          </div>
        );
      })}
    </>
  );
}

function QuestionList({ questions }) {
  return questions?.map((question, index) => {
    switch (question?.questionType) {
      case 'ContextQuestions':
        return (
          <ContextQuestions number={index + 1} question={question?.question} />
        );
      default:
        return (
          <div>
            <AloneQuestion number={index + 1} question={question?.question} />
            <QuestionAnswers answers={question?.question?.questionAnswers} />
          </div>
        );
    }
  });
}

export function WorkShopsPreview(props) {
  const { activity, isLoading } = useActivity();
  const classes = useStyles();

  if (isLoading) {
    return <CircularProgress color="primary" />;
  }

  return (
    <div className={classes.root}>
      <h1 className={classes.evaluationTitle}>{activity?.title}</h1>
      <QuestionList questions={activity?.questions} />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    padding: '40px',
    width: '100%',
  },
  evaluationTitle: {
    fontFamily: 'Roboto',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#000',
    textAlign: 'center',
  },
  contextQuestionRoot: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '30px',
  },
  answerOptionsRoot: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '80px',
  },
  questionAnnouncement: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
  },
  activityImage: {
    width: '500px',
    height: '500px',
    objectFit: 'contain',
    alignSelf: 'center',
  },
  questionDescription: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 'normal',
    color: '#333',
    width: '80%',
    paddingLeft: '30px',
  },
  questionOptions: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 'normal',
    color: '#333',
    marginBottom: '15px',
    marginRight: '10px',
  },
  questionOption: {
    display: 'flex',
    alignItems: 'center',

    // justifyContent: 'space-between',
  },
  questionCorrectIndicator: {
    transform: 'translateY(-8px)',
    fontFamily: 'Roboto',
    fontSize: '16px',
    color: '#050',
  },
  optionImage: {
    width: '100px',
    height: '100px',
    objectFit: 'contain',
    transform: 'translateX(50%)',
  },
  questionImage: {
    width: '300px',
    height: '300px',
    objectFit: 'contain',
    transform: 'translateX(30%)',
  },
}));
